export { default } from './TermsCheckbox';
